angular
	.module 'App.Repository'

.factory 'TenderTypeRepository', ['BaseRepository', (BaseRepository) ->
	class TenderTypeRepository extends BaseRepository
		@resource = '/tender_types'
		@isRestricted = true

	return new TenderTypeRepository
]
